import styled from "styled-components";

export const WeekSelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.06);
  margin-bottom: 40px;
`;

export const WeekTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #222;
  margin: 0;
`;

export const WeeksContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const WeekButton = styled.button`
  padding: 12px 20px;
  border: 2px solid transparent;
  border-radius: 12px;
  background: ${props => props.active ? '#4CAF50' : '#f8f8f8'};
  color: ${props => props.active ? '#fff' : '#333'};
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: ${props => props.active 
    ? '0 4px 12px rgba(76, 175, 80, 0.4)' 
    : '0 2px 6px rgba(0, 0, 0, 0.04)'};

  &:hover {
    background: ${props => props.active ? '#45a049' : '#efefef'};
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  }

  &:focus-visible {
    outline: none;
    border-color: #4CAF50;
  }

  &:active {
    transform: scale(0.98);
  }
`;
